import React, { useEffect, useRef, useState } from 'react';
import {
  AiChatButton,
  AquistaButton,
  AquistaButtonsContainer,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  RightCol,
  RiskCardStyles,
  SavedButton,
} from '../ResultPageComponents/v2/RiskCard.styles';
import { BACKEND_BASE_URL } from '../../../../config';
import ModalsImported from './riskCardReusable/ModalsImported';
import RiskPriceComponent from './riskCardReusable/RiskPriceComponent';
import RiskCompanyInfoComponent from './riskCardReusable/RiskCompanyInfoComponent';
import RiskQuoteInfoComponent from './riskCardReusable/RiskQuoteInfoComponent';
import { Chat } from '../../chats/MiniChat/MiniChat';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';

function RiskCard({
  quote, type, selectQuotation, riskQuotes, requestInfo,
}) {
  const [extraText, setExtraText] = useState(null);
  const [showModalAssistenza, setShowModalAssistenza] = useState(false);
  const [showModalGlobalTutela, setShowModalGlobalTutela] = useState(false);
  const [showModalGlobalInfortuni, setShowModalGlobalInfortuni] = useState(false);
  const [showModalGlobalCristalli, setShowModalGlobalCristalli] = useState(false);
  const [showModalEuropeAssistenza, setShowModalEuropeAssistenza] = useState(false);
  const [showModalEuropeTutela, setShowModalEuropeTutela] = useState(false);
  const [showModalEuropeCristalli, setShowModalEuropeCristalli] = useState(false);
  const [showModalEuropeCollisione, setShowModalEuropeCollisione] = useState(false);
  const [showModalTutelaArag, setShowModalTutelaArag] = useState(false);
  // const [showModalInfortunio, setShowModalInfortunio] = useState(false);
  const [showModalGlobalTutelaProduct, setShowModalGlobalTutelaProduct] = useState(false);

  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();

  const openModal = () => {
    if (quote.quote_type === 'assistenza_stradale') {
      setShowModalAssistenza(!showModalAssistenza);
    }
    if (quote.quote_type === 'tutela_legale' && quote.company_id === 16) {
      setShowModalGlobalTutela(!showModalGlobalTutela);
    }

    if (quote.quote_type === 'tutela_legale' && quote.company_id === 15) {
      setShowModalTutelaArag(!showModalTutelaArag);
    }
    if (quote.quote_type === 'infortuni_conducente') {
      setShowModalGlobalInfortuni(!showModalGlobalInfortuni);
    }
    if (quote.quote_type === 'cristalli') {
      setShowModalGlobalCristalli(!showModalGlobalCristalli);
    }
    // if (quote.product_id === 1002 && quote.quote_type === 'invalidita_permanente_da_infortunio') {
    //   setShowModalInfortunio(!showModalInfortunio);
    // }
    if (quote.product_id === 9 && quote.company_id === 16 && quote.sub_product === 'vita_privata') {
      setShowModalGlobalTutelaProduct(!showModalGlobalTutelaProduct);
    }
  };

  const openModalEurope = () => {
    if (quote.quote_type === 'assistenza_stradale') {
      setShowModalEuropeAssistenza(!showModalEuropeAssistenza);
    }
    if (quote.quote_type === 'tutela_legale') {
      setShowModalEuropeTutela(!showModalEuropeTutela);
    }
    if (quote.quote_type === 'cristalli') {
      setShowModalEuropeCristalli(!showModalEuropeCristalli);
    }
    if (quote.quote_type === 'collisione') {
      setShowModalEuropeCollisione(!showModalEuropeCollisione);
    }
  };

  const getSubProductRisk = () => {
    if (quote.company_id === 1001 && quote.quote_type !== 'res_civile' && quote.product_id === 1) {
      return 'nobis_risk';
    }

    if (quote.company_id === 1005 && quote.product_id === 1) {
      if (quote.quote_type === 'tutela_legale') {
        return 'my_rescue_tutela';
      }

      if (quote.quote_type === 'collisione') {
        return 'my_rescue_collisione';
      }

      if (quote.quote_type === 'assistenza_stradale') {
        return 'my_rescue_assistenza';
      }
    }
    return null;
  };

  useEffect(() => {
    if (requestInfo?.commercial_company?.activity_description) {
      setExtraText((prev) => `${prev} - Tipologia di attività commerciale : ${requestInfo?.commercial_company?.activity_description}`);
    }
  }, [requestInfo]);

  return (
    <RiskCardStyles className={quote.is_aquista === 1 ? 'selected' : ''}>
      <LeftCol>
        {quote.company_id === 1005 && quote.product_id === 1 && (
          <div className="alert alert-danger mt-1 mb-2 p-1">
            Servizio non assicurativo
          </div>
        )}
        {quote.company_id === 9
          && requestInfo.payment_frequency === 2 && (
            <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
              <b>Attenzione:</b>
              {' '}
              Linear non supporta il pagamento semestrale.
            </div>
        )}
        {quote.company_id === 18
          && requestInfo.payment_frequency === 2 && (
            <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
              <b>Attenzione:</b>
              {' '}
              Genial Piu non supporta il pagamento semestrale.
            </div>
        )}
        <AiChatButton onClick={() => setOpenChat(true)}>
          <SparklesIcon width={24} height={24} />
          <span>Chiedi all'AI</span>
        </AiChatButton>
        <Chat
          ref={chatRef}
          openChat={openChat}
          setOpenChat={setOpenChat}
          company_id={quote.company_id}
          product_id={quote.product_id}
          quote_type={quote.quote_type}
          company_name={quote.company.name}
          extraText={extraText}
          sub_product={getSubProductRisk()}
        />
        <ModalsImported
          quote={quote}
          showModalAssistenza={showModalAssistenza}
          setShowModalAssistenza={setShowModalAssistenza}
          showModalGlobalTutela={showModalGlobalTutela}
          setShowModalGlobalTutela={setShowModalGlobalTutela}
          showModalGlobalInfortuni={showModalGlobalInfortuni}
          setShowModalGlobalInfortuni={setShowModalGlobalInfortuni}
          showModalGlobalCristalli={showModalGlobalCristalli}
          setShowModalGlobalCristalli={setShowModalGlobalCristalli}
          showModalEuropeAssistenza={showModalEuropeAssistenza}
          setShowModalEuropeAssistenza={setShowModalEuropeAssistenza}
          showModalEuropeTutela={showModalEuropeTutela}
          setShowModalEuropeTutela={setShowModalEuropeTutela}
          showModalEuropeCristalli={showModalEuropeCristalli}
          setShowModalEuropeCristalli={setShowModalEuropeCristalli}
          showModalEuropeCollisione={showModalEuropeCollisione}
          setShowModalEuropeCollisione={setShowModalEuropeCollisione}
          showModalTutelaArag={showModalTutelaArag}
          setShowModalTutelaArag={setShowModalTutelaArag}
          // showModalInfortunio={showModalInfortunio}
          // setShowModalInfortunio={setShowModalInfortunio}
          setShowModalGlobalTutelaProduct={setShowModalGlobalTutelaProduct}
          showModalGlobalTutelaProduct={showModalGlobalTutelaProduct}
        />
        <LogoPriceContainer>
          <LogoContainer>
            <img
              src={BACKEND_BASE_URL + quote.company.logo}
              alt={quote.company.name}
            />
          </LogoContainer>
          <RiskPriceComponent quote={quote} />
        </LogoPriceContainer>
        <RiskCompanyInfoComponent
          quote={quote}
          openModal={openModal}
          openModalEurope={openModalEurope}
        />
        <RiskQuoteInfoComponent
          quote={quote}
          type={type}
          setExtraText={setExtraText}
          requestInfo={requestInfo}
        />
      </LeftCol>
      <RightCol>
        <AquistaButtonsContainer>
          {riskQuotes
            && riskQuotes[type.id]
            && riskQuotes[type.id].find((q) => q.id === quote.id) !== undefined ? (
              <SavedButton>Aggiunto</SavedButton>
            ) : (
              <AquistaButton
                onClick={() => selectQuotation(quote.id)}
                className="result-profession-sixth-step"
              >
                Seleziona
              </AquistaButton>
            )}
        </AquistaButtonsContainer>
      </RightCol>
    </RiskCardStyles>
  );
}

export default RiskCard;
